import { gql } from "@apollo/client";

export const GET_MINI_QUESTIONS = gql`
  query Query {
    miniQuestionsList {
      total
      questions {
        index
        area
        text
      }
    }
  }
`;

export const GET_LONG_QUESTIONS = gql`
  query Query {
    longQuestionsList {
      total
      questions {
        index
        area
        text
      }
    }
  }
`;

export const GET_QUIZ_PROGRESS = gql`
  query Query {
    quizProgress {
      isCompleted
      isQuizTaken
      answers
      questions {
        total
        questions {
          area
          index
          text
        }
      }
      results {
        start
        answers
        end
        total
        result {
          area
          description
          score
        }
      }
    }
  }
`;
